import getSimpleDateString from './getSimpleDateString';
export default function datesAreEqual(d1, d2) {
    if (d1 === undefined || d1 === 'undefined' || d2 === undefined)
        return false;
    return getSimpleDateString(d1) === getSimpleDateString(d2);
}
